import React from 'react';
import {Checkbox, FormControlLabel, Link, Typography, Grid} from "@mui/material";
import {Link as RouterLink} from "react-router";

interface BookingRentalAgreementCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rentalAgreementUrl: string;
  name: string;
  disabled?: boolean;
}

const linkSx = {
  font: "inherit",
  color: 'rgba(63, 81, 181, 1)',
  textDecoration: 'none',
} as const;

const requiredSx = {
  '&.Mui-required': {
    color: 'tomato',
  },
} as const;

const BookingRentalAgreementCheckbox = (props: BookingRentalAgreementCheckboxProps) => {
  const {checked, onChange, rentalAgreementUrl, name, disabled} = props;

  return(
    <Grid container flexDirection='column'>
      <Grid item>
        <FormControlLabel
          sx={requiredSx}
          label={<Typography variant={'subtitle1'} color='textPrimary' component='span'>Agree to Terms</Typography>}
          control={<Checkbox checked={checked} onChange={onChange} name={name} disabled={disabled} required/>}
          />
      </Grid>
      <Grid item>
          <Typography variant={'subtitle1'} color='textPrimary'>
            By checking this box, you agree to the website <RouterLink to={'/terms-of-use'} target={'_blank'} style={linkSx}>Terms Of Use</RouterLink>, <Link href={rentalAgreementUrl} target={'_blank'} sx={linkSx}>Reservation Agreement</Link>, and agree to pay any and all overages accrued.
          </Typography>
      </Grid>
    </Grid>
  );
};

export default BookingRentalAgreementCheckbox;
